import request from '@/utils/request'

// 查询注销原因列表
export function listUserCancelReason(query) {
  return request({
    url: '/user/cancel/reason/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询注销原因分页
export function pageUserCancelReason(query) {
  return request({
    url: '/user/cancel/reason/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询注销原因详细
export function getUserCancelReason(data) {
  return request({
    url: '/user/cancel/reason/detail',
    method: 'get',
    params: data
  })
}

// 新增注销原因
export function addUserCancelReason(data) {
  return request({
    url: '/user/cancel/reason/add',
    method: 'post',
    data: data
  })
}

// 修改注销原因
export function updateUserCancelReason(data) {
  return request({
    url: '/user/cancel/reason/edit',
    method: 'post',
    data: data
  })
}

// 删除注销原因
export function delUserCancelReason(data) {
  return request({
    url: '/user/cancel/reason/delete',
    method: 'post',
    data: data
  })
}
